<template>
  <component :is="component" v-if="component" />
</template>

<script setup>
import { getComponent } from "#blokkli/helpers/imports";
import { provide, defineBlokkli } from "#imports";
import { INJECT_FRAGMENT_CONTEXT } from "#blokkli/helpers/symbols";
const componentProps = defineProps({
  name: { type: null, required: true }
});
const ctx = defineBlokkli({
  bundle: "blokkli_fragment",
  editor: {
    disableEdit: true
  }
});
const component = getComponent("fragment", componentProps.name);
provide(INJECT_FRAGMENT_CONTEXT, ctx);
</script>
